export const Pproducts = [
  {
    id: '1',
    name: 'The Yard - Building 9',
    title: '',
    imageUrl: './The Yard Website Thumbnail Template.png',
    description: '',
    productLink: '/the-yard',
    isClosed: false,
  },
  {
    id: '1',
    name: 'Logan Land',
    title: '',
    imageUrl: './Logan Land Website Thumbnail.png',
    description: '',
    productLink: '/logan-land',
    isClosed: false,
  },
  // {
  //   id: '1',
  //   name: 'University Barbershop Apartments',
  //   title: '',
  //   imageUrl:
  //     './Barbershop_Thumbnail.png',
  //   description: '',
  //     productLink: '/university-barbershop-apartments',
  //     isClosed: false,
  // },

  {
    id: '1',
    name: 'Weber Heights Apartments',
    title: '',
    imageUrl:
      './weber heights_Thumbnail.jpg',
    description: '',
      productLink: '/weber-heights-apartments',
      isClosed: false,
  },

  // {
  //   id: '1',
  //   name: 'Provo Portfolio',
  //   title: '',
  //   imageUrl:
  //     './Thumbnail_Provo Portfolio.png',
  //   description: '',
  //     productLink: '/provo-portfolio',
  //     isClosed: false,
  // },

  // {
  //   id: '1',
  //   name: 'College Way & Stadium Way',
  //   title: '',
  //   imageUrl:
  //     './cwTH.png',
  //   description: '',
  //     productLink: '/college-way-stadium-way',
  //     isClosed: false,
  // },
  // {
  //   id: '1',
  //   name: 'At Home Rexburg',
  //   title: '',
  //   imageUrl:
  //     './At Home Rexburg Thumbnail.png',
  //   description: '',
  //     productLink: '/at-home-rexburg',
  //     isClosed: false,
  // },
  // {
  //   id: '1',
  //   name: 'Lofts on 34th',
  //   title: '',
  //   imageUrl:
  //     './Lofts on 34th_Thumbnail.jpg',
  //   description: '',
  //     productLink: '/lofts-on-34th',
  //     isClosed: false,
  // },
  // {
  //   id: '1',
  //   name: 'Desert Sage',
  //   title: '',
  //   imageUrl:
  //     './DesertSage_Thumbnail.png',
  //   description: '',
  //     productLink: '/desert-sage-townhomes',
  //     isClosed: false,
  // },


///////////// Closed ///////////
  {
    id: '1',
    name: 'South Salt Lake Portfolio',
    title: '',
    imageUrl: './South Salt Lake Website Thumbnail.png',
    description: '',
    productLink: '/closed-south-salt-lake-portfolio',
    isClosed: true,
  },
  {
    id: '1',
    name: 'Nevada Circle',
    title: '',
    imageUrl: './Nev Circle_Thumbnail.png',
    description: '',
    productLink: '/closed-nevada-circle',
    isClosed: true,
  },
  {
    id: '1',
    name: 'Pointe Portfolio',
    title: '',
    imageUrl: './Pointe_Thumbnail.png',
    description: '',
    productLink: '/closed-pointe-portfolio',
    isClosed: true,
  },
  {
    id: '1',
    name: 'Windsor',
    title: '',
    imageUrl: './Windsor Thumnail.png',
    description: '',
    productLink: '/closed-windsor',
    isClosed: true,
  },
  {
    id: '1',
    name: 'Dixie Cove',
    title: '',
    imageUrl: './Dixie Cove-Thumbnail.png',
    description: '',
    productLink: '/closed-dixie-cove',
    isClosed: true,
  },
{
    id: '1',
    name: 'Quincy Avenue Apartments',
    title: '',
    imageUrl:
      './Quincy_Thumbnail.png',
    description: '',
      productLink: '/closed-quincy-avenue',
      isClosed: true,
  },
 {
    id: '1',
    name: '100 S Apartments | Douglas St 4-Plex',
    title: '',
    imageUrl:
      './Burnett_Portfolio Thumbnail.jpg',
    description: '',
      productLink: '/closed-100-s-554-douglas-st',
      isClosed: true,
  },
{
    id: '1',
    name: 'Connie Jean',
    title: '',
    imageUrl:
      './Connie Jean_Thumbnail.png',
    description: '',
      productLink: '/closed-connie-jean',
      isClosed: true,
  },
{
  id: '1',
  name: '2nd Avenue Apartments',
  title: '',
  imageUrl:
    './2nd Ave_Thumbnail.png',
  description: '',
    productLink: '/closed-second-avenue',
    isClosed: true,
},
{
  id: '1',
  name: 'Twin Pines',
  title: '',
  imageUrl:
    './TP-Thumbnail.png',
  description: '',
    productLink: '/closed-twin-pines',
    isClosed: true,
},
  {
    id: '1',
    name: 'The Grand Portfolio',
    title: '',
    imageUrl:
      './Grand Portfolio_Thumbnail.png',
    description: '',
      productLink: '/closed-the-grand-portfolio',
      isClosed: true,
  },

  {
    id: '3',
    name: 'Revive Apartments',
    title: 'S',
    imageUrl:
      './_Revive Apartments_Aerial Square.png',
    description:
      '',
      productLink: '/closed-revive',
      isClosed: true,
  },
     {
    id: '1',
    name: 'Shulsen Lane',
    title: '',
    imageUrl:
      './shulsen-lane-thumbnail.jpg',
    description: '',
      productLink: '/closed-shulsen-lane',
      isClosed: true,
  },
    {
      id: '5',
      name: 'Murray Park View',
      title: 'S',
      imageUrl:
        './_Murray Park View_Exterior Square.png',
      description:
        '',
        productLink: '/closed-murray-park-view',
        isClosed: true,
    },
    {
      id: '6',
      name: 'MODA Spring Run',
      title: 'S',
      imageUrl:
        './_MODA Spring Run_Aerial Square.png',
      description:
        '',
        productLink: '/closed-moda-spring-run',
        isClosed: true,
    },
    {
      id: '7',
      name: 'Villas at Fern Circle',
      title: 'S',
      imageUrl:
        './_Fern_Circle_Square.png',
      description:
        '',
        productLink: '/closed-villas-at-fern-circle',
        isClosed: true,
    },
  ]
